import { getRandomUUID } from './common-util';

export const SESSION_ID_KEYS = {
    metricsTabId: 'metricsTabId',
    sessionId: 'sessionId',
};
// Session setter and getter
const getSessionId = () => {
    let sessionId = sessionStorage.getItem(SESSION_ID_KEYS.sessionId);
    if (!sessionId) {
        sessionId = getRandomUUID();
        sessionStorage.setItem(SESSION_ID_KEYS.sessionId, sessionId);
    }
    return sessionId;
};
const setSessionId = (id) => {
    sessionStorage.setItem(SESSION_ID_KEYS.sessionId, id);
};

export {
    getSessionId,
    setSessionId,
};
